<template>
  <div class="messages">
    <ChatMessage
      v-for="(message, index) in messages"
      :key="index"
      :message="message"
      class="messages__item"
    />
  </div>
</template>

<script>
import ChatMessage from '@/components/chat/ChatMessage'

export default {
  components: {
    ChatMessage,
  },

  props: {
    messages: { type: Array, default: () => [] },
  }
}
</script>

<style lang="scss" scoped>
  .messages {
    &__item:not(:last-child) {
      margin-bottom: 14px;
    }
  }
</style>